import api from "../axios";

export async function getPatientReadingMetrics(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/reading-metrics/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}

export async function getDeviceMetrics(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/device-metrics/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}

export async function getComplianceTrend(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/compliance-trend/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}
